import { postRequest } from '../../../shared/utils';

export async function getAllTableColumnConfigQuery({ screenGridId, configSchema, tableId }) {
  const body = {
    columns: [
      'attr_internal_name',
      'attr_display_name_en',
      'attr_display_name_de',
      'attr_data_type',
      'attr_duplicate_config',
      'attr_mandatory',
      'form_order_no',
      'id',
      'attr_available_in_grid',
      'attr_group_id',
      'attribute_config_id',
      'attr_managed_by_admin',
    ],
    screenGridId,
    schema: configSchema,
    table: 'v_screen_grid_attribute_config',
    key: 'screen_grid_id',
    value: tableId,
    orderCol: 'id',
    order: 'desc',
  };
  const { errors, data } = await postRequest('/api/records', body);

  if (errors) {
    return { errors };
  }
  return data;
}
